<template>
  
</template>

<script>
export default {
  name:"LoggingStore",
  inject: ['functionLoggingPage'],
  data(){
    return {
      logs:[],
      baseURL: `https://fandango-wombat-7897.twil.io/tc_admin?k=${this.$_auid}`,
    }
  },
  watch: {
    syncClient: function(){
      if (this.syncClient === undefined)
        return;
      this.syncClient.list('logging').then(list => {

        list.getItems({order:'desc', pageSize:1000, limit:1000}).then(_list=>{
          // window.debugList = list
          // window.debugListItems = _list
          this.logs = _list.items

          //Lazy Pagination BAD DESIGN
          list.getItems({pageToken:_list.nextToken}).then(_list2=>{
            this.logs = [...this.logs, ..._list2.items]
            list.getItems({pageToken:_list2.nextToken}).then(_list3=>{
              this.logs = [...this.logs, ..._list3.items]
              list.getItems({pageToken:_list3.nextToken}).then(_list4=>{
                this.logs = [...this.logs, ..._list4.items]
              })
            })
          })
        })

        // Listen to updates on the List
        list.on('itemAdded', item => {
          this.logs.push(item.item);
        });
        
      });
      
    }
  },
  methods:{
    log(key, data){
      let url = `${this.baseURL}&m=log&key=${encodeURI(key)}&data=${encodeURI(data)}`;
      //should be changed in the future to this.$axios (but without X-ATL-AUTH)
      axios.get(url)
    },
    clearLogs(){
      this.logs = [];
    },
  },
  computed:{
    sortedLogs(){
      return this.$util.sortDescForKeyPath(this.logs, 'data.value.ts');
    },
    twilioSyncStore(){
      return this.functionLoggingPage.$refs.twilioSyncStore
    },
    syncClient(){
      return this.twilioSyncStore.syncClient
    }
  },
}
</script>